var map = {
	"./prod.config.json": 274,
	"./qa.config.json": 275,
	"./stg.config.json": 276
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.config\.json$
// module id = 273
// module chunks = 0